import React, { useEffect, useState } from "react";

import { useDispatch, useSelector } from "react-redux";
import { StyledContainer } from "./styles";

import { useMediaQuery } from "react-responsive";
import { useHistory, useLocation } from "react-router-dom";

import { AllClientHeader } from "./components/AllClientHeader";

import { AllProjectsTable } from "./components/allProjectsTable";
import { GoBackButton } from "pages/buyers/components/goBackButton";
import {
  getClientProjectsInfo,
  getClientProjectsInfoForWipUnderwriter,
} from "data/actions/underwriters";
import { clientProjectsSelector } from "data/selectors/underwriters";
import { getSingleProject } from "api/prequalify";
import { saveProject } from "api/dashboard";
import { AddProjectPopup } from "components/addProjectPopup";
import { filterProjects } from "api/prequalify";

const AllProjectPage = () => {
  const isMobile = useMediaQuery({ maxWidth: 453 });
  const location = useLocation();
  const dispatch = useDispatch();
  const companyName = location.state?.company_name || "";
  const accountId = location.state?.account_id;
  const institutionId = location.state?.institutionId;
  const clientProjects = useSelector(clientProjectsSelector);
  const [project, setProject] = useState("");
  const [openPopup, setOpenPopup] = useState(false);
  let history = useHistory();
  const [data, setData] = useState([]);
  const [query, setQuery] = useState("");
  const [internalSearchResults, setInternalSearchResults] = useState(data);

  const user = JSON.parse(localStorage.getItem("User"));
  const isAgentUnderwriter = user?.is_agent_to_access_esub_and_idp || false;

  useEffect(() => {
    if (isAgentUnderwriter) {
      filterProjects(query, { institution_id: institutionId, user_id: location.state?.userId || "" })
      .then((data) => {
        setData(data);
      })
      .catch((err) => {});
    } else {
      dispatch(getClientProjectsInfoForWipUnderwriter(
        { account_id: accountId },
        "completed",
      ));
      dispatch(getClientProjectsInfo({ account_id: accountId }));
    }
  }, []);
  useEffect(() => {
    if (!isAgentUnderwriter && clientProjects) {
      setData(clientProjects);
    }
  }, [clientProjects]);
  const handleGoBack = () => {
    history.push("/underwriter-dashboard");
  };

  const addProject = (data) => {
    saveProject(data, onSuccess, () => {});
  };

  const onSuccess = () => {
    setProject("");
  };

  const editProject = (id) => {
    getSingleProject(id, onSuccessEdit, () => {});
  };
  const onSuccessEdit = (res) => {
    setProject(res);
    setOpenPopup(true);
  };

  return (
    <StyledContainer isMobile={isMobile}>
      <GoBackButton />
      <AllClientHeader
        title="All Projects of"
        subTitle={companyName}
        hasButton={true}
        data={data}
        setData={setData}
        query={query}
        setQuery={setQuery}
        internalSearchResults={internalSearchResults}
        setInternalSearchResults={setInternalSearchResults}
        // handleButton={handleStartNew}
        marginBottom="0"
      />
      {data && (
        <AllProjectsTable
          data={query && query !== "" ? internalSearchResults : data}
          setData={setData}
          clientCompanyName={companyName}
          editFunc={editProject}
        />
      )}
    </StyledContainer>
  );
};

export default AllProjectPage;
